import mutations from './mutations';

const state = () => ({
    date_info: "all",
});

const getters = {
    get_date_info: state => state.date_info,
};

const actions = {
    setDateInfo({ commit }, data) {
        commit('setDateInfo', data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};